<route>
{
    "name": "auth-oidc-callback",
    "path": "/auth/oidc/callback",
    "meta": {
        "title": "Autentificare",
        "permission": "guest",
        "fail": "/404"
    }
}
</route>

<template>
  <modal-layout class="white">
    <v-card :flat="true">
      <v-card-text class="text-xs-center py-5">
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-card-text>
    </v-card>
  </modal-layout>
</template>

<script>
import ModalLayout from "Layouts/ModalLayout.vue";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("auth");

export default {
  components: {
    ModalLayout
  },
  mounted() {
    this.completeOidcLogin();
  },
  methods: {
    ...mapActions({
      completeOidcLogin: "completeOidcLogin"
    })
  }
};
</script>
